module.exports = __webpack_public_path__ + "img/buttonUpIcon.cf41cf2d.svg";